export default "__VITE_ASSET__j9zFpD1y__"